import IconButton from "@mui/material/IconButton";
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { Props } from "./Props";

export function PortfolioItemActions({
    disabled,
    action,
}: Props) {
    const changingVolumeStep = 1;
    
    return (
        <>
            <IconButton
                color="success"
                onClick={() => action(changingVolumeStep)}
                size="small"
                sx={{padding:'0px'}}
                {...(disabled
                    ? { disabled: true }
                    : {})}
            >
                <AddBoxIcon />
            </IconButton>
            <IconButton
                color="primary"
                onClick={() => action(-changingVolumeStep)}
                size="small"
                sx={{padding:'0px'}}
                {...(disabled
                    ? { disabled: true }
                    : {})}
            >
                <IndeterminateCheckBoxIcon />
            </IconButton>
        </>
    )
}